import dayjs from "dayjs"
import { DATE_FORMAT_SHOW } from "src/utils/constants"
import { formataNumeroCasadeMilhar, formatStringToFloatDecimalCase } from "src/utils/format-decimal"

const getDate = (data, key) => {
    if (data == null || data[key] == null) return "-"
    return dayjs(data[key]).format(DATE_FORMAT_SHOW)
}

const getValueFormated = (data, key) => {
    if (data == null || data[key] == null) return "-"
    return formatStringToFloatDecimalCase(data[key])
}

const getValue = (data, key, { defaultValue = "-" } = {}) => {
    if (data == null) return defaultValue
    return data[key] !== null && data[key] !== undefined ? data[key] : defaultValue
}

const getValueInflacaoAnual = (data, key, { defaultValue = null } = {}) => {
    if (data == null) return "-"

    const inflacaoAnual =
        data[key] !== null && data[key] !== undefined ? data[key] : defaultValue

    if (inflacaoAnual != null) {
        return inflacaoAnual == 1 ? "Sim" : "Não"
    }

    return "-"
}

const getParametrosSections = (data) => [
    {
        fields: [
            { label: "Tipo Juros PUPAR", value: getValue(data, "TipoJurosPUPAR"), xs: 6, sm: 6, md: 3 },
            { label: "Tipo Capitalização PUPAR", value: getValue(data, "TipoCapitalizacaoPUPAR"), xs: 6, sm: 6, md: 3 },
            { label: "Tipo Juros PU MTM", value: getValue(data, "TipoJurosPU_MTM"), xs: 6, sm: 6, md: 3 },
            { label: "Tipo Capitalização PU MTM", value: getValue(data, "TipoCapitalizacaoPU_MTM"), xs: 6, sm: 6, md: 3 },
        ],
    },
    {
        fields: [
            { label: "Início Rentabilidade", value: getDate(data, "InicioRentabilidade"), xs: 6, sm: 6, md: 3 },
            { label: "Inflação Anual", value: getValueInflacaoAnual(data, "InflacaoAnual", { defaultValue: "Não se aplica" }), xs: 6, sm: 6, md: 3 },
            { label: "Fim Rentabilidade", value: getDate(data, "FimRentabilidade"), xs: 6, sm: 6, md: 3 },
            { label: "Mês Aniversário", value: getValue(data, "MesAniversario"), xs: 6, sm: 6, md: 3 },
        ],
    },
    {
        fields: [
            { label: "Valor Nominal", value: getValueFormated(data, "ValorNominal"), xs: 6, sm: 6, md: 3 },
            { label: "Projeção Inflação", value: getValue(data, "ProjecaoInflacao"), xs: 6, sm: 6, md: 3 },
            { label: "Defasagem", value: getValue(data, "Defasagem"), xs: 6, sm: 6, md: 3 },
            { label: "Inflação Negativa", value: getValue(data, "InflacaoNegativa", { defaultValue: "Não se aplica" }), xs: 6, sm: 6, md: 3 },
        ],
    },
]

const getResultadoSections = (data, hasResultado) => [
    {
        type: "table",
        columns: [
            { label: "CETIP", key: "CETIP", flex: 1, minWidth: 100 },
            { label: "ISIN", key: "ISIN", flex: 1, minWidth: 130 },
            {
                label: "Data Referência",
                key: "DataReferencia",
                flex: 1,
                minWidth: 140,
                formatter: (value) => (value ? dayjs(value).format(DATE_FORMAT_SHOW) : "-"),
            },
            { label: "Indicador", key: "Indicador", flex: 1, minWidth: 110 },
            { label: "Taxa Accrual", key: "TaxaAccrual", flex: 1, minWidth: 120, formatter: (value) => formatStringToFloatDecimalCase(value) },
            { label: "Taxa MTM", key: "TaxaMTM", flex: 1, minWidth: 110, formatter: (value) => formatStringToFloatDecimalCase(value) },
            { label: "Spread Crédito", key: "SpreadCredito", flex: 1, minWidth: 130, formatter: (value) => formatStringToFloatDecimalCase(value) },
            { label: "Duration DU", key: "DurationDU", flex: 1, minWidth: 120, formatter: (value) => formatStringToFloatDecimalCase(value) },
            { label: "PU MTM", key: "PU_MTM", flex: 1, minWidth: 110, formatter: (value) => formatStringToFloatDecimalCase(value) },
            { label: "PUPAR", key: "PUPAR", flex: 1, minWidth: 110, formatter: (value) => formatStringToFloatDecimalCase(value) },
            { label: "%PUPAR", key: "%PUPAR", flex: 1, minWidth: 110, formatter: (value) => formatStringToFloatDecimalCase(value) },
        ],
        // Só cria a linha se o endpoint realmente devolveu resultado —
        // um array vazio [] não deve virar linha de traços.
        rows: hasResultado && data ? [data] : [],
    },
]

const FLUXO_COLUMNS = [
    { label: "Fluxo", key: "Fluxo", flex: 1, minWidth: 90 },
    { label: "Data Evento", key: "DataEvento", flex: 1, minWidth: 130, formatter: (value) => (value ? dayjs(value).format(DATE_FORMAT_SHOW) : "-") },
    { label: "Data Liquidação", key: "DataLiquidacao", flex: 1, minWidth: 140, formatter: (value) => (value ? dayjs(value).format(DATE_FORMAT_SHOW) : "-") },
    { label: "DU", key: "DU", flex: 1, minWidth: 90, formatter: (value) => formataNumeroCasadeMilhar(value) },
    { label: "%Amortização Ordinária", key: "AmortizacaoOrdinariaPercentual", flex: 1, minWidth: 150, formatter: (value) => formatStringToFloatDecimalCase(value) },
    { label: "%Amortização Extraordinária", key: "AmortizacaoExtraordinariaPercentual", flex: 1, minWidth: 160, formatter: (value) => formatStringToFloatDecimalCase(value) },
    { label: "%Correção Indicador", key: "CorrecaoIndicadorPercentual", flex: 1, minWidth: 140, formatter: (value) => formatStringToFloatDecimalCase(value) },
    { label: "%Juros", key: "JurosPercentual", flex: 1, minWidth: 100, formatter: (value) => formatStringToFloatDecimalCase(value) },
    { label: "%Juros Incorporação", key: "IncorporacaoJurosPercentual", flex: 1, minWidth: 150, formatter: (value) => formatStringToFloatDecimalCase(value) },
    { label: "Valor Nominal", key: "ValorNominal", flex: 1, minWidth: 130, formatter: (value) => formatStringToFloatDecimalCase(value) },
    { label: "VNA", key: "VNA", flex: 1, minWidth: 100, formatter: (value) => formatStringToFloatDecimalCase(value) },
    { label: "Amortização Ordinária", key: "AmortizacaoOrdinaria", flex: 1, minWidth: 150, formatter: (value) => formatStringToFloatDecimalCase(value) },
    { label: "Amortização Extraordinária", key: "AmortizacaoExtraordinaria", flex: 1, minWidth: 160, formatter: (value) => formatStringToFloatDecimalCase(value) },
    { label: "Juros", key: "Juros", flex: 1, minWidth: 100, formatter: (value) => formatStringToFloatDecimalCase(value) },
    { label: "Juros Incorporação", key: "IncorporacaoJuros", flex: 1, minWidth: 150, formatter: (value) => formatStringToFloatDecimalCase(value) },
    { label: "Prêmio", key: "Premio", flex: 1, minWidth: 100, formatter: (value) => formatStringToFloatDecimalCase(value) },
    { label: "Pagamento", key: "Pagamento", flex: 1, minWidth: 110, formatter: (value) => formatStringToFloatDecimalCase(value) },
    { label: "%Taxa VF", key: "TaxaVF", flex: 1, minWidth: 100, formatter: (value) => formatStringToFloatDecimalCase(value) },
    { label: "Valor Futuro", key: "ValorFuturo", flex: 1, minWidth: 120, formatter: (value) => formatStringToFloatDecimalCase(value) },
    { label: "%Taxa VP", key: "TaxaVP", flex: 1, minWidth: 100, formatter: (value) => formatStringToFloatDecimalCase(value) },
]

const getPuparSections = (puparData) => [
    {
        type: "table",
        columns: [
            ...FLUXO_COLUMNS,
            { label: "PUPAR", key: "PUPAR", flex: 1, minWidth: 110, formatter: (value) => formatStringToFloatDecimalCase(value) },
        ],
        rows: puparData ?? [],
    },
]

const getPuMtmSections = (puMtmData) => [
    {
        type: "table",
        columns: [
            ...FLUXO_COLUMNS,
            { label: "PU MTM", key: "PU_MTM", flex: 1, minWidth: 110, formatter: (value) => formatStringToFloatDecimalCase(value) },
        ],
        rows: puMtmData ?? [],
    },
]

export const getMemoriaCalculoModalConfig = ({ data, hasResultado, puparData, puMtmData }) => ({
    parametros: {
        title: "Parâmetros para Cálculo de Preços",
        sections: getParametrosSections(data),
    },
    resultado: {
        title: "Resultado",
        sections: getResultadoSections(data, hasResultado),
    },
    pupar: {
        title: "Memória de Cálculo PUPAR",
        sections: getPuparSections(puparData),
    },
    pu_mtm: {
        title: "Memória de Cálculo PU MTM",
        sections: getPuMtmSections(puMtmData),
    },
})